import { initializeApp } from 'firebase/app';
import { getMessaging, onMessage } from 'firebase/messaging';
import { toast } from 'react-toastify';

const firebaseConfig = {
  apiKey: 'AIzaSyCaL3zIAD1pWysHrze77V1I69sh2bZE014',
  authDomain: 'pelinternal.firebaseapp.com',
  projectId: 'pelinternal',
  storageBucket: 'pelinternal.firebasestorage.app',
  messagingSenderId: '981122667337',
  appId: '1:981122667337:web:8ea5f1289d404cc6574098',
  measurementId: 'G-LPY8MNZV5T',
};

const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);

onMessage(messaging, (payload) => {
  console.log('🔥 FCM MESSAGE RECEIVED (global):', payload);

  const { type, status } = payload.data || {};

  if (type === 'DEVICE_STATUS_UPDATE') {
    console.log('📱 Device status update received:', status);

    const channel = new BroadcastChannel('device_status_channel');
    channel.postMessage({ type, status });
    channel.close();
    return;
  }

  // Foreground push (CRM tab is open): the browser won't show the OS
  // notification itself, so surface it as an in-app toast. Clicking navigates
  // to the linked page when provided.
  if (payload.notification) {
    const { title, body } = payload.notification;
    const link =
      (payload as any)?.fcmOptions?.link || payload.data?.link || '';
    toast.info(`${title ? `${title}: ` : ''}${body || ''}`, {
      onClick: () => {
        if (link) window.location.href = link;
      },
    });
  }
});

export const onMessageListener = () => {
  return new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log('message payload :>>', payload);
      resolve(payload);
    });
  });
};
